module.exports = __webpack_public_path__ + "static/img/empty@2x.413cd5ce.png";